var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"id":"mapModal"}},[_c('button',{staticClass:"FullScreen",on:{"click":_vm.close}},[_c('font-awesome-icon',{attrs:{"icon":"expand"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }